import type { SVGProps } from 'react';

export const DocumentOnDocumentSFSymbolMedium = (
  props: SVGProps<SVGSVGElement>
) => {
  return (
    <svg
      height="1em"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 20.6748 24.8633"
      fill="currentColor"
      {...props}
    >
      <g>
        {' '}
        <rect height="24.8633" opacity="0" width="20.6748" x="0" y="0" />{' '}
        <path
          d="M4.83125 3.20351C4.83125 1.10195 5.91718 0 8.00272 0L11.6726 0C12.7967 0 13.675 0.291796 14.4053 1.03984L19.2754 5.99512C20.0465 6.78574 20.3135 7.60546 20.3135 8.88925L20.3135 16.6291C20.3135 18.7289 19.2275 19.8326 17.142 19.8326L15.484 19.8326L15.484 17.9193L16.975 17.9193C17.9238 17.9193 18.4002 17.4182 18.4002 16.5102L18.4002 8.42421L14.0918 8.42421C12.8914 8.42421 12.2549 7.7957 12.2549 6.5873L12.2549 1.91327L8.16171 1.91327C7.21287 1.91327 6.74451 2.42245 6.74451 3.32245L6.74451 5.01016L6.74451 5.01016C6.68975 5.00884 6.6329 5.00839 6.5748 5.00839L4.83125 5.00839ZM13.8519 6.3459C13.8519 6.68066 13.9904 6.82715 14.3252 6.82715L17.9022 6.82715L13.8519 2.71288Z"
          fill="currentColor"
        />{' '}
        <path
          d="M0 21.6375C0 23.7471 1.07968 24.841 3.17148 24.841L12.3125 24.841C14.4043 24.841 15.484 23.7373 15.484 21.6375L15.484 14.1213C15.484 12.8133 15.3182 12.2014 14.5 11.3672L9.20702 5.99238C8.42089 5.19023 7.75116 5.00839 6.5748 5.00839L3.17148 5.00839C1.08769 5.00839 0 6.10234 0 8.2119ZM1.91327 21.5186L1.91327 8.32284C1.91327 7.43084 2.38163 6.92166 3.33222 6.92166L6.3332 6.92166L6.3332 12.2676C6.3332 13.6668 7.025 14.3488 8.40643 14.3488L13.5689 14.3488L13.5689 21.5186C13.5689 22.4266 13.0926 22.9277 12.1518 22.9277L3.32421 22.9277C2.38163 22.9277 1.91327 22.4266 1.91327 21.5186ZM8.5955 12.6615C8.19257 12.6615 8.0205 12.4912 8.0205 12.0865L8.0205 7.29705L13.3031 12.6615Z"
          fill="currentColor"
        />{' '}
      </g>
    </svg>
  );
};
